import { dateToApiFormat } from '@/helpers/dateHelper';
import { Location, useGetPublishedRosteredStaffInDateRangeQuery } from '@/services/gql/graphql.generated';
import { RosteredEmployeeIdAndSchedule, useGetMeQuery, useGetShiftOperatingHoursQuery } from '../gql/graphql.generated';
import { useMyLocation } from '../useLocations';

export interface ShiftDetailsForDay extends RosteredEmployeeIdAndSchedule {
  location: Location;
  openTime?: number;
  closeTime?: number;
}

const useRosterForDay = (date: Date, userId: string | undefined): ShiftDetailsForDay | undefined => {
  const selectedLocation = useMyLocation();
  const selectedLocationId = selectedLocation.id;

  const [{ data: operatingHoursData }] = useGetShiftOperatingHoursQuery({
    variables: {
      locationId: selectedLocationId,
      start: dateToApiFormat(date),
      end: dateToApiFormat(date)
    }
  });

  const [{ data: rosterData }] = useGetPublishedRosteredStaffInDateRangeQuery({
    variables: {
      startDate: dateToApiFormat(date),
      endDate: dateToApiFormat(date),
      locationId: selectedLocationId
    },
    requestPolicy: 'cache-and-network'
  });

  const shift = rosterData?.publishedRosteredStaffInDateRange?.find(s => s.identityId === userId);
  if (!shift) return undefined;

  const operatingHours = operatingHoursData?.shiftOperatingHoursInDateRange?.[0];

  return {
    ...shift,
    location: selectedLocation,
    openTime: operatingHours?.openTime,
    closeTime: operatingHours?.closeTime
  };
};
export const useMyShiftDetailsForDay = (date: Date) => {
  const [{ data: myData }] = useGetMeQuery();
  const userId = myData?.myEmployee?.identityId;

  return useRosterForDay(date, userId);
};

export const useShiftDetailsForDayByUserId = (date: Date, userId: string) => {
  return useRosterForDay(date, userId);
};
